import { useAppSelector } from 'src/app/hooks';
import { Permission } from 'src/constants/Permission';
import { hasPermissions } from 'src/utils/hasPermission';
import PAGES from 'src/pageTree';

export function useHasPermissions(permissions?: keyof typeof PAGES | Permission[] | null) {
  const perfil = useAppSelector((state) => state.page.perfil);
  return hasPermissions({ perfil, permissions });
}

export function useHasPermissionsMulti(
  multiPermissions: (keyof typeof PAGES | Permission[] | null)[]
) {
  const perfil = useAppSelector((state) => state.page.perfil);
  const resultAr: boolean[] = [];
  for (const permissions of multiPermissions) {
    const result = hasPermissions({ perfil, permissions });
    resultAr.push(result);
  }
  return resultAr;
}
